<template>
  <div class="row">
    <app-overlay-loader v-if="preloader" />
    <div class="col-sm-12 col-md-12">
      <div class="card-body">
       <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl"
      >
         <div class="form-group row align-items-center">
          <label class="col-sm-4 mb-0">{{ $t("document_category") }}</label>
          <app-input
            class="col-sm-8"
            type="search-select"
            :placeholder="$t('select_document_category')"
            :list="documentCategories"
            v-model="category_id"
          />
        </div>
        <div class="form-group row align-items-center" v-if="subCategory.length > 0">
          <label class="col-sm-4 mb-0">{{ $t("sub_category") }}</label>
          <app-input
            class="col-sm-8"
            type="search-select"
            :placeholder="$t('select_sub_category')"
            :list="subCategory"
            v-model="subcategory_id"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_type" class="col-sm-4 mb-0">
            {{ $t("type") }}
          </label>
          <app-input
            id="inputs_type"
            class="col-sm-8"
            type="text"
            v-model="inputs.type"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_document_name" class="col-sm-4 mb-0">
            {{ $t("document_name") }}
          </label>
          <app-input
            id="inputs_document_name"
            class="col-sm-8"
            type="text"
            v-model="inputs.document_name"
            :required="true"
          />
        </div>  
        <div class="form-group row align-items-center">
          <label for="inputs_phone" class="col-sm-4 mb-0">
            {{ $t("expiry_date") }}
          </label>
          <app-input
            id="inputs_expiry_date"
            class="col-sm-8"
            type="date"
            v-model="inputs.expiry_date"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_description" class="col-sm-4 mb-0">
            {{ $t("description") }}
          </label>
          <app-input
            id="inputs_edescription"
            class="col-sm-8"
            type="textarea"
            v-model="inputs.description"
          />
        </div>
         <div v-if="fields.length">
          <div class="form-group row align-items-center" v-for="(type, index) in fields" :key="index">
            <label for="inputs_document_name" class="col-sm-4 mb-0">
              {{ type.field }}
            </label>
            <app-input
              id="inputs_document_name"
              class="col-sm-8"
              type="text"
              v-model="extra_fields[type.id]"
              :required="true"
            />
          </div>
        </div>
        <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-4 mb-0">
              {{ $t("is_public") }}
            </label>
            <app-input
              class="mt-2 pt-1 col-sm-6"
              type="radio"
              :list="publicradio"
              v-model="inputs.is_public"
              :required="true"
            />
          </div>
        <div class="form-group row mb-0">
            <label class="col-sm-4 mb-sm-0">
              {{ $t("upload") }}
            </label>
              <app-input
                class="col-sm-8"
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
              />
              <!-- <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small> -->
          </div>
        <!-- <div class="form-group row align-items-center">
          <div class="col-sm-12 mb-0">
            <label for="inputs_status">
              {{ $t("upload") }}
            </label>
            <app-input
              type="dropzone"
              :required="true"
              v-model="dropzone_files"
            />
            <small class="text-muted font-italic">
              {{ $t("recommended_dropzone_file_validation") }}
            </small>
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div
            class="col-lg-2 col-md-2 col-sm-12"
            v-for="(val, index) in uploade_files"
            :key="index"
          >
            <div class="form-group">
              <img :src="val.path" alt="uploaded file" class="img-thumbnail" />
            </div>
            <span
              class="dz-remove"
              style="cursor: pointer"
              @click="deletefile(val.id, index)"
              >Remove file</span
            >
          </div>
        </div> -->
        <div class="form-group row align-items-center">
          <div class="col-sm-12 mb-0">
            <button
              type="submit"
              class="btn btn-primary mr-2"
              @click.prevent="submit"
            >
              {{ $t("submit") }}
            </button>
          </div>
        </div>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
import { MYDOCUMENT_STORE, DOCUMENT_CATEGORIES, DOCUMENT_EXTRA_FIELDS, DOCUMENT_SUB_CATEGORIES } from "../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../Helpers/AppLibrary";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";

export default {
  name: "FileUpload",
  extends: AppLibrary,
  mixins: [FormMixin],

  data() {
    return {
      file:'',
      preloader: false,
      addurl: MYDOCUMENT_STORE,
      documentCategories: [],
      subCategory:[],
      dropzone_files: [],
      inputs: {
        expiry_date: new Date(),
      },
      extra_fields: {},
      fields: [],
      category_id: '',
      subcategory_id: '',
      publicradio: [
        { id: "1", value: "Yes" },
        { id: "0", value: "No" },
      ],
    };
  },
  methods: {
    submit() {

      if (this.inputs.expiry_date)
        this.inputs.expiry_date = this.getDateFormatForBackend(
          this.inputs.expiry_date
        );
      if (this.$store.state.sharedData && this.$store.state.sharedData.sharedData.guestUserData){
        this.inputs.user_id = this.$store.state.sharedData.sharedData.guestUserData.id;
        this.inputs.guest = true;
      }
      this.inputs.category_id = this.category_id;
        // this.inputs = this.extra_fields;
        
        let formData = new FormData();
        // if (this.dropzone_files.length) {
        //   this.dropzone_files.forEach((dropzone_file) =>
        //     formData.append(`dropzone_file[]`, dropzone_file)
        //   );
        // }

        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });

        let data = [];
        Object.entries(this.extra_fields).forEach((obj) => {
          data = [...data,obj];
        });
        formData.append('extra',JSON.stringify(data));

        this.save(formData);
    },
    beforeSubmit(){
      this.preloader = true;
    },
    afterSuccess(response) {
      this.preloader = false;
      this.inputs = {};
      this.$toastr.s(response.data.message);
      this.file = response.data.file;
    //   
    },
    getDocumentCategories() {
      axiosGet(DOCUMENT_CATEGORIES)
        .then((res) => {
          this.documentCategories = res.data;
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {});
    },
    getDocumentFields(id) {
      
      axiosGet(DOCUMENT_EXTRA_FIELDS + '/' + id)
        .then((res) => {
          this.fields = res.data;
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {});
    },
    getSubCategory(id) {
      axiosGet(DOCUMENT_SUB_CATEGORIES+ '/' + id)
        .then((res) => {
          this.subCategory = res.data;
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {});

    },
  },
  mounted() {
    this.getDocumentCategories();
  },
  watch: {
    category_id() {
      let category_id = this.category_id
      this.getDocumentFields(category_id);

      //Sub CAtegory
      this.getSubCategory(category_id);
    },
    subcategory_id() {

      let category_id = this.category_id
      this.getDocumentFields(category_id);
      
      let subcategory_id = this.subcategory_id
      this.getDocumentFields(subcategory_id);
    }
  },
};
</script>
